import React, { useEffect, useState } from "react";
import styles from "./UserPage.module.scss";
import TableTopHeader from "../../Molecules/TableTopHeader/TableTopHeader";
import UsersTable from "../../Molecules/Users/UsersTable";
import DeletePopup from "../../Molecules/Custom/DeletePopup";
import UserModal from "../../Molecules/Users/UserModal";
import ViewUserModal from "../../Molecules/Users/ViewUserModal";
import UserRoleModal from "../../Molecules/Users/RolesModal/UserRoleModal";

import { useExportTableUsers, useFetchUsers } from "../../../Hooks/Users";
import { useDeleteUser } from "../../../Hooks/Users";
import { toast } from "react-toastify";
import { useToast } from "../../Molecules/Custom/CustomToaster/Toast";
import ResetPasswordForm from "../../Molecules/Users/ResetPasswordForm";
import { usePageAccess } from "../../../Context/PageAccessContext";

const UsersPage = () => {
  const [selected, setSelected] = useState("users");
  const [mode, setMode] = useState("users");
  const [deleteMode, setDeleteMode] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewModal, setViewModal] = useState("");
  const [modalMode, setModalMode] = useState("add");
  const [assignRole, setAssignRole] = useState(false);
  const [resetPassword, setResetPasword] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [usersPage, setUsersPage] = useState(1);
  const [eachUser, setEachUser] = useState(null);
  const [usersPageSize, setUsersPageSize] = useState(10);
  const [selectedUser, setSelectedUser] = useState({});
  const [search, setSearch] = useState();
  const [order, setOrder] = useState(["", "asc"]);
  const { mutate: deleteUser, isLoading: isdeletingUser } = useDeleteUser();
  const customizedToast = useToast();
 const tableHeader = [
   {
     name: 'الاسم الأول',
     originalName: 'fullName_En',
   },
   {
     name: 'اسم العائلة',
     originalName: 'fullName_AR',
   },
   {
     name: 'البريد الإلكتروني',
     originalName: 'email',
   },
   {
     name: 'رقم الجوال',
     originalName: 'mobile',
   },
   {
     name: 'الصفحات المخصصة',
     originalName: 'userRoles',
   },
 ];


  const {
    data: users,
    refetch: refetchUsers,
    isLoading: isUsersLoading,
  } = useFetchUsers({
    pageSize: usersPageSize,
    pageNumber: usersPage,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const {
    data: usersPrint,
    refetch: refetchUsersPrint,
    isLoading: isUsersLoadingPrint,
  } = useFetchUsers({
    pageSize: 1000000000,
    pageNumber: 1,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  /**
   * The assignable-page list comes from the SAME place the sidebar and the
   * route gate read it (`Context/PageAccessContext`), rather than from a third
   * `GetRolePages` call of its own.
   *
   * That is not only one request less. It is the guarantee the feature rests
   * on: the rows an administrator ticks here are, by construction, the rows
   * that decide what appears in that user's menu and what the gate lets them
   * open. They cannot be two different lists any more.
   */
  const { rolePages } = usePageAccess();

  const exportTableUsers = useExportTableUsers();

  const handleAddClick = () => {
    setIsModalOpen(true);
    setModalMode("add");
    setEachUser(null);
  };

  const handleEditClick = () => {
    setIsModalOpen(true);
    setModalMode("edit");
  };

  const handleExportUsersTable = async () => {
    try {
      const data = await exportTableUsers.mutateAsync();
      if (data.data instanceof Blob) {
        const blob = new Blob([data.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "UsersTable";
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        console.error("Unexpected data type. Expected string.");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  useEffect(() => {
    if (selected === "users") {
      setMode("users");
      refetchUsers();
    } else {
      setMode("roles");
    }
    setSearch("");
  }, [selected]);

  useEffect(() => {
    return setSelectedUsers([]);
  }, []);
  //--------------------------------------------------------------
  // `oneUser` used to be assembled here and handed to both modals as a second,
  // reshaped copy of `eachUser`. Neither modal ever read its `pages`, and both
  // now derive the selection from `userRoles` themselves (PagesTree), so the
  // duplicate has gone rather than being kept in step by hand.
  //--------------------------------------------------------------

  useEffect(() => {
    setMode("users");
    refetchUsers();
  }, [usersPage, usersPageSize]);

  //------------------------------------------------------------------------------

  const handleDelete = (array) => {
    deleteUser(array, {
      onSuccess: () => {
        refetchUsers();
        setSelectedUsers([]);
        setDeleteMode(false);
        setViewModal(false);
        customizedToast.open('تم الحذف بنجاح');
      },
      onError: (error, data) => {
        console.error("An error occurred:", error?.response?.data?.message);
        toast.error("Email or username already exists");
        // setErrorMessage(error?.response?.data?.message);
      },
    });
  };
  //------------------------------------------------------------------------------
  useEffect(() => {
    refetchUsers();
  }, [search]);
  //------------------------------------------------------------------------------

  return (
    <>
      <div>
        <div className={styles['table-container']}>
          <TableTopHeader
            rowsCount={users?.data.length}
            selectedUser={selectedUser}
            mode={mode}
            user={true}
            handleOnAdd={handleAddClick}
            handleExport={handleExportUsersTable}
            search={search}
            setSearch={setSearch}
            setDeleteMode={setDeleteMode}
            refetchUsers={refetchUsers}
            data={usersPrint}
            tableHeader={tableHeader}
            refetch={refetchUsersPrint}
          />
          <UsersTable
            data={users?.data}
            tableHeader={tableHeader}
            setViewModal={setViewModal}
            setDeleteMode={setDeleteMode}
            handleEditClick={handleEditClick}
            selected={selectedUsers}
            setSelected={setSelectedUsers}
            page={usersPage}
            setPage={setUsersPage}
            setSelectedUser={setSelectedUser}
            pageSize={usersPageSize}
            setPageSize={setUsersPageSize}
            isUsersLoading={isUsersLoading}
            setIsModalOpen={setIsModalOpen}
            setModalMode={setModalMode}
            setEachUser={setEachUser}
            setAssignRole={setAssignRole}
            order={order}
            setOrder={setOrder}
            refetchUsers={refetchUsers}
            pagesDataCount={rolePages?.length}
            setResetPasword={setResetPasword}
          />
        </div>
      </div>

      {deleteMode && (
        <DeletePopup
          title={selected === 'users' ? 'مستخدم' : 'دور'}
          handleOnClose={() => setDeleteMode(false)}
          handleDelete={handleDelete}
          selectedUser={selectedUser}
          isLoading={isdeletingUser}
        />
      )}
      {isModalOpen && mode === 'users' && (
        <UserModal
          pagesData={rolePages}
          mode={modalMode}
          eachUser={eachUser}
          title="مستخدم"
          handleOnClose={() => setIsModalOpen(false)}
          refetchUsers={refetchUsers}
        />
      )}

      {viewModal && (
        <ViewUserModal
          mode={modalMode}
          eachUser={eachUser}
          setDeleteMode={setDeleteMode}
          setIsModalOpen={setIsModalOpen}
          setModalMode={setModalMode}
          handleOnClose={() => setViewModal('')}
        />
      )}

      {assignRole && (
        <UserRoleModal
          handleOnClose={() => setAssignRole(false)}
          pagesData={rolePages}
          eachUser={eachUser}
          refetchUsers={refetchUsers}
        />
      )}

      {resetPassword && (
        <ResetPasswordForm
          eachUser={eachUser}
          handleOnClose={() => setResetPasword(false)}
          refetchUsers={refetchUsers}
        />
      )}
    </>
  );
};

export default UsersPage;
